import { lazy, type ReactNode } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';

const LandingPage = lazy(() => import('@/pages/landing/page'));
const HomePage = lazy(() => import('@/pages/home/page'));
const ArchitecturePage = lazy(() => import('@/pages/architecture/page'));
const AdminPage = lazy(() => import('@/pages/admin/page'));
const LoginPage = lazy(() => import('@/pages/login/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));

function AuthGuard({ children }: { children: ReactNode }) {
  const token = localStorage.getItem('auth_token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/chat" replace />,
  },
  {
    path: '/landing',
    element: <LandingPage />,
  },
  {
    path: '/index',
    element: <Navigate to="/chat" replace />,
  },
  {
    path: '/chat',
    element: <HomePage />,
  },
  {
    path: '/architecture',
    element: <ArchitecturePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/admin',
    element: (
      <AuthGuard>
        <AdminPage />
      </AuthGuard>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
